import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
    selector: 'TextDirectionDirective'
})
export class TextDirectionDirective {
    private editorElement: HTMLElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.editorElement = this.el.nativeElement;
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        this.updateDirectionClass();
    }

    private updateDirectionClass() {
        const content = this.editorElement.innerText;

        // Remove existing direction classes
        this.renderer.removeClass(this.editorElement, 'rtl');
        this.renderer.removeClass(this.editorElement, 'ltr');

        // Add class based on content
        if (/[\u0600-\u06FF]/.test(content)) {
            this.renderer.addClass(this.editorElement, 'rtl');
        } else {
            this.renderer.addClass(this.editorElement, 'ltr');
        }
    }
}
